<template>
  <div
    class="has-text-left"
    :class="{'direction-rtl': Language == 'fa' || Language == 'ar'}"
  >

    <div class="box">
      <h4
        class="title"
        :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
      >
        <span class="has-text-danger">{{$t("price_estimate")}}</span>
      </h4>
      <p
        class="subtitle"
        :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
      >{{ $t('lydiax_withdrawal_note', { currency: User.wallet.currency, crypto: selectedCrypto.name || 'crypto'}) }}</p>

      <div
        class="box"
        :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
      >
        <div class="field">
          <p
            class="control"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
          >
            <label for="estimate">{{ $t('enter_currency_amount', { currency: User.wallet.currency}) }}</label>
            <input
              class="input"
              v-validate="'decimal:10'"
              name="estimate"
              type="text"
              v-model="estimate.fiat"
            />
            <span
              v-show="errors.has('estimate')"
              :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
              class="help is-danger"
            >{{ errors.first('estimate') }}</span>
          </p>
        </div>

        <a
          class="button is-success"
          @click="estimatePrice"
        >
          <span class="icon is-small">
            <i
              class="fa fa-check"
              :class="{'ml-10': Language == 'fa' || Language == 'ar'}"
            ></i>
          </span>
          <span>{{ $t('check_price') }}</span>
        </a>

        <span
          class="is-size-5 has-text-danger"
          v-if="estimate.crypto"
        >{{ $t('estimated') }} {{ estimate.crypto.toFixed(10) }} {{ selectedCrypto.code || 'crypto' }}</span>
      </div>
    </div>

    <h5
      class="title is-fullwidth"
      :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
    >{{$t("select_cryptocurrency")}}</h5>
    <div
      class="field"
      :class="{'is-pulled-right': Language == 'fa' || Language == 'ar', 'is-pulled-left' : Language != 'fa' && Language != 'ar'}"
    >
      <div class="control">
        <span class="select">
          <select
            name="currency"
            v-model="cryptocurrency"
            @change="$validator.clean()"
          >
            <option
              v-if="crypto.code !== 'ETH'"
              :value="crypto.code"
              v-for="(crypto, i) in cryptocurrencyOptions"
              :key="'crypto-options-' + i"
            >{{ crypto.name }}</option>
          </select>
        </span>
      </div>
    </div>
    <br />

    <br />

    <div v-if="networkOpts.length > 1">
      <h5
        class="title"
        style="margin-bottom:10px"
      >Select your {{cryptocurrency}} network:</h5>
      <div class="control">
        <span class="select">
          <select
            name="currency"
            v-model="network"
          >
            <option
              :value="netw"
              v-for="(netw, i) in networkOpts"
              :key="'network-' + i"
            >{{ netw }}</option>
          </select>
        </span>
      </div>
    </div>
    <br />

    <div
      v-if="networkWarning[cryptocurrency] && networkWarning[cryptocurrency].length > 0"
      class="has-text-danger"
    >
      <!-- {{networkWarning[cryptocurrency]}} -->
      <div v-if="cryptocurrency=='BTC'">
        {{$t('bitpace_network_warning_BTC_withdrawal')}}
      </div>
      <div v-else-if="cryptocurrency=='ETH'">

      </div>
      <div v-else-if="cryptocurrency=='LTC'">
        {{$t('bitpace_network_warning_LTC_withdrawal')}}
      </div>
      <div v-else-if="cryptocurrency=='XRP'">
        {{$t('bitpace_network_warning_XRP_withdrawal')}}
      </div>
      <div v-else-if="cryptocurrency=='BCH'">
        {{$t('bitpace_network_warning_BCH_withdrawal')}}
      </div>
      <div v-else-if="cryptocurrency=='USDT'">
        {{$t('bitpace_network_warning_USDT_withdrawal')}}
      </div>
      <div v-else-if="cryptocurrency=='USDC'">
        {{$t('bitpace_network_warning_USDC_withdrawal')}}
      </div>
      <div v-else-if="cryptocurrency=='TRX'">
        {{$t('bitpace_network_warning_TRX_withdrawal')}}
      </div>
      <div v-else-if="cryptocurrency=='LINK'">
        {{$t('bitpace_network_warning_LINK_withdrawal')}}
      </div>
    </div>

    <br />
    <h5
      class="title is-fullwidth"
      :class="{'is-pulled-right': Language == 'fa' || Language == 'ar', 'is-pulled-left' : Language != 'fa' && Language != 'ar'}"
    >{{ $t('please_enter_your_crypto_address', { crypto: selectedCrypto.name}) }}</h5>
    <!-- <p class="subtitle"></p> -->

    <div class="field">
      <p class="control">
        <input
          v-validate="'required'"
          :class="{'input': true, 'is-danger': errors.has('cryptoAddress') }"
          name="cryptoAddress"
          type="text"
          :data-vv-as="$t('your_crypto_address', {crypto: this.selectedCrypto.name})"
          :placeholder="$t('your_crypto_address', {crypto: this.selectedCrypto.name})"
          v-model="cryptoAddress"
        />
        <span
          v-show="errors.has('cryptoAddress')"
          class="help is-danger"
          :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
        >{{ errors.first('cryptoAddress') }}</span>
      </p>
    </div>

    <div
      class="field"
      v-if="selectedCrypto.code === 'XRP'"
    >
      <p class="control">
        <input
          v-validate="'required'"
          :class="{'input': true, 'is-danger': errors.has('destinationTag') }"
          name="destinationTag"
          type="text"
          :data-vv-as="$t('destination_tag')"
          :placeholder="$t('destination_tag')"
          v-model="destinationTag"
        />
        <span
          v-show="errors.has('destinationTag')"
          class="help is-danger"
          :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
        >{{ errors.first('destinationTag') }}</span>
      </p>
    </div>

    <div class="field">
      <label
        for="OTP"
        class="label"
        :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
      >{{$t("otp")}}</label>
      <div class="columns">
        <div class="column is-8">
          <input
            v-validate="'required'"
            :class="{'input': true, 'is-danger': errors.has('OTP') }"
            name="OTP"
            type="text"
            :data-vv-as="'OTP'"
            :placeholder="'OTP'"
            v-model="OTP"
          />
          <span
            v-show="errors.has('OTP')"
            class="help is-danger"
            :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
          >{{ errors.first('OTP') }}</span>
        </div>
        <div class="column is-4">
          <button
            :disabled="!otpBtnEnabled"
            @click="generateOTP()"
          >{{$t("otp_send_email")}}</button>
        </div>
      </div>
    </div>

    <!-- <div
      class="has-text-danger"
      style="font-weight:700; font-size:1.25rem; margin-bottom: 0;"
      v-if="selectedCrypto.fees.withdrawal"
    >
      Please note that a {{ selectedCrypto.fees.withdrawal }} {{ cryptocurrency }} fee will be applied.
    </div> -->
    <br />
    <div class="field has-addons">
      <p class="control">
        <a class="button is-static">{{currencySymbols[User.wallet.currency].symbol}}</a>
      </p>
      <p class="control">
        <input
          v-if="User.wallet.currency === 'USD'"
          v-validate="'required|currency|min_value:65'"
          :class="{'input': true, 'is-danger': errors.has('amount') }"
          name="amount"
          type="text"
          :data-vv-as="$t('amount')"
          :placeholder="$t('amount')"
          v-model="amount"
        />
        <input
          v-else
          v-validate="'required|currency|min_value:50'"
          :class="{'input': true, 'is-danger': errors.has('amount') }"
          name="amount"
          type="text"
          :data-vv-as="$t('amount')"
          :placeholder="$t('amount')"
          v-model="amount"
        />
        <span
          v-show="errors.has('amount')"
          class="help is-danger"
          :class="{'has-text-right': Language == 'fa' || Language == 'ar'}"
        >{{ errors.first('amount') }}</span>
      </p>
      <p class="control">
        <a
          class="button is-success"
          @click="withdraw"
        >
          <span class="icon is-small">
            <i
              class="fa fa-check"
              :class="{'ml-10': Language == 'fa' || Language == 'ar'}"
            ></i>
          </span>
          <span>{{$t("withdraw").tTitle()}}</span>
        </a>
      </p>
    </div>

  </div>
</template>

<script>
// import {service} from '../../../app'
import config from '../../../config'
import { mapActions, mapGetters } from 'vuex'
import { service } from '../../../app'

export default {
  data() {
    return {
      amount: 0,
      cryptoAddress: '',
      cryptocurrency: 'BTC',
      cryptocurrencyOptions: config.cryptocurrencyOptions,
      otpBtnEnabled: true,
      OTP: '',
      destinationTag: '',
      currencySymbols: config.currencies,
      estimate: {
        crypto: 0,
        fiat: 0,
        raw: {},
      },
      network: '',
      networkOpts: [],
      networkWarning: {
        BTC: this.$t('bitpace_network_warning_BTC_withdrawal'),
        ETH: '',
        LTC: this.$t('bitpace_network_warning_LTC_withdrawal'),
        XRP: this.$t('bitpace_network_warning_XRP_withdrawal'),
        BCH: this.$t('bitpace_network_warning_BCH_withdrawal'),
        USDT: this.$t('bitpace_network_warning_USDT_withdrawal'),
        USDC: this.$t('bitpace_network_warning_USDC_withdrawal'),
        TRX: this.$t('bitpace_network_warning_TRX_withdrawal'),
        LINK: this.$t('bitpace_network_warning_LINK_withdrawal'),
      },
    }
  },
  // watch: {},
  watch: {
    cryptocurrency() {
      this.networkOpts = this.selectedCrypto.networks
      if (this.networkOpts.length == 0) {
        this.network = ''
      }
      if (this.networkOpts.length == 1) {
        this.network = this.networkOpts[0]
      }
    },
  },
  computed: {
    selectedCrypto() {
      return this.cryptocurrencyOptions.filter(c => c.code === this.cryptocurrency)[0]
    },
    ...mapGetters({
      User: 'user/all',
      Language: 'language/code',
    }),
  },
  mounted() {
    this.networkOpts = this.selectedCrypto.networks

    this.network = this.networkOpts[0]
  },
  methods: {
    estimatePrice() {
      this.estimate.crypto = 0
      this.estimate.raw = {}

      this['logoLoader/set'](true)
      service
        .post('finance/get-lydiax-price', {
          order_type: 'buy',
          crypto: this.cryptocurrency,
        })
        .then(response => {
          const orderPrice = response.data
          if (orderPrice.currency !== this.User.wallet.currency) {
            service.get('/finance/rates/' + orderPrice.currency + '/' + this.User.wallet.currency).then(response => {
              this.estimate.crypto = this.estimate.fiat / (orderPrice.price * response.data.rate)
            })
          } else {
            this.estimate.crypto = this.estimate.fiat / orderPrice.price
          }

          this.estimate.raw = orderPrice
          this['logoLoader/set'](false)
        })
        .catch(error => {
          console.log(error)
          this['logoLoader/set'](false)
        })
    },
    withdraw() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$bus.$emit('RequestWithdraw', '/finance/withdraw', {
            amount: String(this.amount),
            userID: this.$store.state.user.info.ID,
            psp: 'lydiax',
            extraInfo: JSON.stringify({
              address: this.cryptoAddress,
              cryptocurrency: this.cryptocurrency,
              destinationTag: this.destinationTag,
              network: this.cryptocurrency === 'USDT' || this.cryptocurrency === 'USDC' ? this.network : '',
            }),
            OTP: this.OTP,
          })
        }
      })
    },
    generateOTP() {
      service
        .post('/finance/generate-otp', {
          userID: this.$store.state.user.info.ID,
          additionalText: this.$t('lydiax_withdrawal_additional_note'),
        })
        .then(response => {
          if (response.data.success) {
            this.$toasted.success(this.$t('otp_new_password'))
          } else {
            this.$toasted.error(this.$t('otp_error'))
          }
        })
        .catch(error => {
          this.$toasted.error('Error - Failed to send OTP - ' + error)
        })
      this.otpBtnEnabled = false
      setTimeout(
        function () {
          this.otpBtnEnabled = true
        }.bind(this),
        15000
      )
    },
    ...mapActions(['logoLoader/set']),
  },
}
</script>

<style lang="scss" scoped>
label {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// Lydiax.vue?cf4f2064